import React, {useContext} from 'react';
import './QuotationResponseTable.css';
import {ReactComponent as IconCheck} from "../../../assets/images/ic_check.svg"
import {ReactComponent as IconCross} from "../../../assets/images/ic_close.svg"
import RadioButton from "./RadioButton";
import QuotationResponseTableHeader from "./QuotationResponseTableHeader";
import AffinityContext from "../../../context/AffinityContext";

function QuotationResponseTable(props) {
    const {
        title,
        displayFooter,
        nombreModelo,
        detallesCobertura,
        changeSelectedId,
        selectedId,
    } = props;
    const {coberturaMotovehiculoInfo} = useContext(AffinityContext);

    return (
        <div className="cotable__container">
            <table>
                <thead>
                <tr>
                    {/*Columna fija*/}
                    <th>
                        <div className="cotable__white-space">
                            <p className="cotable__model">{nombreModelo}</p>
                            <p className="cotable__title">{title}</p>
                        </div>
                    </th>

                    {/*Columnas móviles*/}
                    {detallesCobertura['nombreCobertura'].map((cobertura, idx) => (
                        <th className={selectedId === idx ? "cotable__column__selected" : ""}>
                            <div className="cotable__white-space">
                                <QuotationResponseTableHeader
                                    coverage={cobertura}
                                    premium={detallesCobertura['premium'][idx]}
                                    selected={selectedId === idx}
                                />
                            </div>

                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {Object.keys(coberturaMotovehiculoInfo['names']).map(key => (
                    <tr>
                        {/*Columna fija*/}
                        <td className="cotable__white-space cotable__text">{coberturaMotovehiculoInfo['names'][key]}</td>

                        {/*Columnas móviles*/}
                        {detallesCobertura['plans'].map((keyValue, idx) => {
                            if (selectedId === idx) {
                                return (<td className="cotable__cell cotable__column__selected">
                                    {coberturaMotovehiculoInfo[keyValue.toString()][key]
                                        ? <IconCheck className="cotable__icon cotable__icon--check--selected"/>
                                        : <IconCross className="cotable__icon cotable__icon--cross--selected"/>}
                                </td>)
                            } else {
                                return (<td className="cotable__cell">
                                    {coberturaMotovehiculoInfo[keyValue.toString()][key]
                                        ? <IconCheck className="cotable__icon cotable__icon--check"/>
                                        : <IconCross className="cotable__icon cotable__icon--cross"/>}
                                </td>)
                            }
                        })}
                    </tr>
                ))}
                </tbody>

                {displayFooter &&
                <tfoot>

                <tr>
                    <td className="cotable__white-space">
                        <p className="cotable__footer__text">Seleccioná tu cobertura</p>
                    </td>
                    {detallesCobertura['nombreCobertura'].map((cobertura, idx) => (
                        <td className={selectedId === idx ? "cotable__column__selected" : ""}>
                            <div className="cotable__radioButton__container">
                                <RadioButton id={idx} callback={changeSelectedId}
                                             selected={selectedId === idx}/>
                            </div>
                        </td>
                    ))}
                </tr>

                </tfoot>
                }
            </table>
        </div>
    );
}

export default QuotationResponseTable;